<template>
  <div class="page-view"></div>
</template>

<script>
import { getcouponScan } from "@/api/member";
export default {
  name: "Index",
  data() {
    return {
      BatchId: "",
    };
  },
  created() {
    this.BatchId = this.$route.query.BatchId;
    if (!this.BatchId) {
      this.$toast("缺少必要参数", "middle");
      return;
    }
    this.queryCouponsInformation();
  },

  methods: {
    queryCouponsInformation() {
      getcouponScan({
        BatchId: this.BatchId,
      }).then((res) => {
        if (res === -1) {
          this.$router.push({
            name: "Memberinformation",
          });
        } else {
          this.$router.push({
            name: "MyCouponList",
          });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.page-view {
}
</style>
